import * as React from 'react'
import * as style from './index.module.css'

interface Props {
  /** テキストタイプ */
  readonly type: 'Mission' | 'Vision' | 'Value'
  /** タイトル */
  readonly title: string
  /** 概要 */
  readonly discription?: string
}

/**
 * @file `mission`, `vision`, `value`のタイトル部分の共通components
 */
export const Mvv = ({ type, title, discription }: Props): React.JSX.Element => {
  return (
    <div className={style.root}>
      <p className={`${style.text} ${style.subTitle}`}>{`“Our ${type}”`}</p>
      <h2
        className={`${style.text} ${style.title} ${
          type === 'Mission' ? style.missionTitle : ''
        }`}
      >
        {title}
      </h2>
      <p className={`${style.text} ${style.discription}`}>{discription}</p>
    </div>
  )
}
